<template>
  <vue-content-loading :width="300" :height="200">
    <template v-if="$vuetify.breakpoint.xsOnly">
      <rect
        v-bind="textAttributesMobile"
        x="100"
        y="0"
        width="100"
        height="100"/>
      <rect v-bind="textAttributesMobile" x="0" y="120" />
      <rect v-bind="textAttributesMobile" x="0" y="150" />
      <rect v-bind="textAttributesMobile" x="0" y="180" />
    </template>
    <template v-else>
      <rect v-bind="textAttributes" x="50" y="0" />
      <rect v-bind="textAttributes" x="50" y="10" />
      <rect v-bind="textAttributes" x="52" y="30" />
      <rect v-bind="textAttributes" x="50" y="40" />
    </template>
  </vue-content-loading>
</template>

<script>
import VueContentLoading from 'vue-content-loading';

export default {
  components: {
    VueContentLoading,
  },
  data() {
    return {
      borderRadius: 4,
      textHeight: 8,
      textWidth: 175,
    };
  },
  computed: {
    borderRadiusAttributes() {
      return {
        rx: this.borderRadius,
        ry: this.borderRadius,
      };
    },
    textAttributes() {
      return {
        ...this.borderRadiusAttributes,
        height: this.textHeight,
        width: this.textWidth,
        'padding-left': '150px',
      };
    },
    textAttributesMobile() {
      const mobileMultiplier = 2;
      return {
        ...this.borderRadiusAttributes,
        height: this.textHeight * mobileMultiplier,
        width: '100%',
      };
    },
  },
};
</script>
